import { ApiAttributionModel } from "@incendium/api";
import { Portal, Stack } from "@mui/material";
import { PageActionPreSlot } from "consts";
import AnalyticsAttributionSwitcher from "features/analytics/components/AnalyticsAttributionSwitcher";
import { CallbackOrVal } from "Interfaces";
import { useAttributionContext } from "Providers/AttributionProvider";
import { useCallback } from "react";

const withAttribution = (Comp: React.ComponentType<any>) => {
  return (props) => {
    const { model, setModel } = useAttributionContext();
    const onChange = useCallback(
      (v: CallbackOrVal<ApiAttributionModel[]>) => {
        setModel(v[0] || ApiAttributionModel.EBA);
      },
      [setModel]
    );
    return (
      <>
        <Portal container={() => document.getElementById(PageActionPreSlot)}>
          <Stack direction={"row"} spacing={2} justifyContent="flex-end">
            <AnalyticsAttributionSwitcher
              collapsible
              models={[model]}
              setModels={onChange}
              withBg
            />
          </Stack>
        </Portal>
        <Comp {...(props as any)} />
      </>
    );
  };
};

export default withAttribution;
